import { useEffect, useRef, useCallback } from 'react';
/**
 *  useOutsideClick hook
 *
 * Checks if a click happened outside a Ref. Handy for dropdowns, modals and popups etc.
 *
 * @param ref Ref whose outside click needs to be listened to
 * @param handler Callback to fire on outside click
 * @param when A boolean which which activates the hook only when it is true. Useful for conditionally enable the outside click
 */
function useOutsideClick(ref, handler, when) {
    if (when === void 0) { when = true; }
    var savedHandler = useRef(handler);
    var memoizedCallback = useCallback(function (e) {
        var element = ref && 'current' in ref ? ref.current : ref;
        if (!(element === null || element === void 0 ? void 0 : element.contains(e.composedPath()[0]))) {
            savedHandler.current(e);
        }
    }, [ref]);
    useEffect(function () {
        if (!when)
            return;
        savedHandler.current = handler;
        document.addEventListener('click', memoizedCallback);
        document.addEventListener('ontouchstart', memoizedCallback);
        return function () {
            document.removeEventListener('click', memoizedCallback);
            document.removeEventListener('ontouchstart', memoizedCallback);
        };
    }, [ref, handler, when, memoizedCallback]);
}
export default useOutsideClick;
//# sourceMappingURL=useOutsideClick.js.map